import React, { useState } from "react";

interface FirstTimeWelcomeScreenProps {
  userName?: string;
  onGetStarted?: () => void;
}

function FirstTimeWelcomeScreen({ userName, onGetStarted }: FirstTimeWelcomeScreenProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [isExiting, setIsExiting] = useState(false);

  const firstName = `${String(userName ?? 'there')}`.trim().split(' ')[0] || 'there';

  const handleGetStarted = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsExiting(true);
      setTimeout(() => onGetStarted?.(), 400);
    }, 1500);
  };
  return (
    <>
      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeOut {
          from { opacity: 1; transform: scale(1); }
          to { opacity: 0; transform: scale(0.95); }
        }
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
        @keyframes wave {
          0%, 100% { transform: rotate(0deg); }
          20% { transform: rotate(15deg); }
          40% { transform: rotate(-15deg); }
          60% { transform: rotate(12deg); }
          80% { transform: rotate(-8deg); }
        }
        @keyframes wordReveal {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .ani-1 { animation: fadeInUp 0.6s ease-out 0.1s both; }
        .ani-2 { animation: fadeInUp 0.6s ease-out 0.3s both; }
        .ani-3 { animation: fadeInUp 0.6s ease-out 0.5s both; }
        .exiting { animation: fadeOut 0.4s ease-in forwards; }
        .spinner { animation: spin 1.2s linear infinite; }
        .wave-emoji { display: inline-block; transform-origin: 70% 70%; animation: wave 1.4s ease-in-out 0.5s both; }
        .reveal-word { display: inline-block; opacity: 0; animation: wordReveal 0.35s ease-out forwards; }
      `}</style>
      <div style={{height:"100vh",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"space-between",padding:`max(16px, env(safe-area-inset-top)) 12px max(16px, env(safe-area-inset-bottom))`,background:"linear-gradient(180deg, #f0f5ff 0%, #e8f2ff 100%)",fontFamily:"-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",transition:"all 0.4s ease",opacity:isExiting?0:1,transform:isExiting?"scale(0.95)":"scale(1)"}} className={isExiting?"exiting":""}>
        <div className="ani-1" style={{display:"flex",flexDirection:"column",alignItems:"center",gap:6}}>
          <img src="/Afdani-logo.png" alt="AFDANI Logo" style={{height:44,objectFit:"contain"}} />
          <h1 style={{margin:"6px 0 4px",fontSize:18,fontWeight:800,color:"#122033",lineHeight:1.2,textAlign:"center"}}>Welcome to <span style={{color:"#1ea97f"}}>AFDANI</span></h1>
          <div style={{fontSize:10,color:"#6b7b93"}}>Smart Inventory Marketplace</div>
          <h1 style={{margin:"6px 0 4px",fontSize:18,fontWeight:800,color:"#122033",lineHeight:1.2,textAlign:"center"}}>
            <span className="wave-emoji">👋</span>
            <span className="reveal-word" style={{animationDelay:'0.2s', marginLeft: 6}}>Hello</span>
            <span className="reveal-word" style={{animationDelay:'0.35s', marginLeft: 8, color:'#1ea97f'}}>{firstName}</span>
          </h1>
          <p style={{margin:0,fontSize:12,lineHeight:1.4,color:"#5d6c82",textAlign:"center",maxWidth:300}}>Manage your inventory, connect with partners, and grow your business—all in one place.</p>
        </div>
        <img className="ani-2" src="/NewFirstUser.png" alt="AFDANI Welcome" style={{width:"100%",maxWidth:340,height:"auto",borderRadius:14,objectFit:"contain",margin:"12px 0"}} />
        <div className="ani-3" style={{display:"flex",flexDirection:"column",gap:8,width:"100%",maxWidth:300}}>
          <button type="button" onClick={handleGetStarted} disabled={isLoading} style={{border:"none",borderRadius:999,padding:"11px 16px",fontSize:14,fontWeight:700,color:"#fff",background:isLoading?"#7b8da0":"linear-gradient(135deg, #3657ff 0%, #1ea97f 100%)",cursor:isLoading?"not-allowed":"pointer",boxShadow:isLoading?"none":"0 10px 28px rgba(54, 87, 255, 0.24)",transition:"all 200ms ease",display:"flex",alignItems:"center",justifyContent:"center",gap:4,opacity:isLoading?0.8:1}} onMouseOver={(e)=>{if(!isLoading){e.currentTarget.style.boxShadow="0 14px 32px rgba(54, 87, 255, 0.32)";e.currentTarget.style.transform="translateY(-1px)"}}} onMouseOut={(e)=>{if(!isLoading){e.currentTarget.style.boxShadow="0 10px 28px rgba(54, 87, 255, 0.24)";e.currentTarget.style.transform="translateY(0)"}}}>{isLoading?<><div className="spinner" style={{width:16,height:16,border:"2px solid rgba(255,255,255,0.3)",borderTop:"2px solid #fff",borderRadius:"50%"}}></div><span style={{marginLeft:8}}>Loading...</span></>:<><span>Let's Get Started</span><span>→</span></>}</button>
          <div style={{textAlign:"center",fontSize:11,color:"#7b8da0"}}><span style={{marginRight:3}}>✓</span>Trusted by Scrap Dealers</div>
        </div>
      </div>
    </>
  );
}

export default FirstTimeWelcomeScreen;
